export default __webpack_public_path__ + "static/media/call.4a0955f1.svg";